import React, { useContext } from "react";
import { ArticleDisplayControl } from "./controls/ArticleDisplayControl";
import { SettingsContext } from "../../../infrastructure/SettingsContext";
import { useLocation } from "react-router-dom";

export const ArticleView = ({ type }) => {
    const { settings } = useContext(SettingsContext);
    const { articleId } = useLocation();
    return (
        <div className="view article-view">
            <ArticleDisplayControl dataId={articleId} type={type} userRole={settings.USER_ROLE} />
        </div>
    );
};
